
webpack.register(
    'modules/player-recap-header/player-recap-header',
    function() {
        return import('modules/player-recap-header/player-recap-header');
    },
    true
);